@for (paragraph of message?.paragraphs; track $index; let i = $index) {
  @if (shouldRenderMarkdown(i)) {
    <div class="paragraph-content">
      <span
        [innerHTML]="paragraph.text | markdown: { mermaid: true, disableSanitizer: true } | async"
        [appReferenceInject]="paragraph.references"
        (referenceClicked)="sourceSelected.emit($event)"
        appTableExport
      ></span>
    </div>
  } @else {
    <span class="mermaid-loading"
      ><i class="fas fa-spinner fa-spin"></i> Generating diagram...</span
    >
  }
}
